import { Injectable } from '@angular/core';
import { AppSettings } from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import { AutenticacionService } from './autenticacion.service';
import { map } from 'rxjs/operators';
import {ProductoReglaNegocio} from '../_models/producto-regla-negocio';

@Injectable({
  providedIn: 'root'
})
export class ProductoReglaNegocioService {
  private rutServicio = AppSettings.rutServiciosAPL + '/api/productosReglasNegocios';

  constructor( private httClient: HttpClient, private autServicio: AutenticacionService ) {
  }

  listado() {
    return this.httClient.get( this.rutServicio ).pipe( map( res => res as ProductoReglaNegocio ) );
  }

  listadoproductosreglanegocio(idProducto:string) {
    return this.httClient.get( this.rutServicio + '/producto/'+idProducto).pipe( map( res => res as ProductoReglaNegocio[] ) );
  }

  listadoPorProducto( idProducto: string ) {
    return this.httClient.get( this.rutServicio + '/producto/' + idProducto ).pipe( map( res => res as ProductoReglaNegocio[] ) );
  }

  obtenerPorId( id: string ) {
    return this.httClient.get( this.rutServicio + '/' + id ).pipe( map( res => res as ProductoReglaNegocio ) );
  }

  crear( regCrear: ProductoReglaNegocio ) {
    return this.httClient.post( this.rutServicio, regCrear ).pipe( map( res => res as ProductoReglaNegocio ) );
  }

  actualizar( regActualizar: ProductoReglaNegocio ) {
    return this.httClient.put( this.rutServicio, regActualizar ).pipe( map( res => res as any ) );
  }

}
